/**
 * @date 15.01.2021
 * @time 00:43
 * @param url
 */
export function normalizeUrl(url: string) {
    if (/^http(s)?:/.test(url)) {
        return url;
    }

    if (/^\/?public\//.test(url)) {
        return url.replace(/^\/?public/, '');
    }

    if (!/^\//.test(url)) {
        return `/${url}`;
    }

    return url;
}

/**
 * @date 15.01.2021
 * @time 00:43
 * @param url
 */
export function normalizeWebsite(url: any): string {
    if (!url) {
        return '';
    }

    if (/^http/.test(url)) {
        return url;
    }

    return `//${url}`;
}
